import React, { useEffect, useState } from "react";
import DeleteIncome from "../../../Controllers/Admin/Income/DeleteIncome";

import GetAllIncomes from "../../../Controllers/Admin/Income/GetAllIncomes";

const IncomeViewModal = () => {
  const [AllIncome, setAllAllIncome] = useState();
  const [Refresh, setRefresh] = useState(false);
  const [IncomeId, setIncomeId] = useState();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      let resp = await GetAllIncomes();
      if (resp) {
        setAllAllIncome([...resp]);
      }
      setIsLoading(false);
    };
    fetchData();
  }, [Refresh]);

  // Action Confirmation Start
  const [DeleteDialog, setDeleteDialog] = useState(false);

  const handleOpenDeleteDialog = (id) => {
    setIncomeId(id);
    setDeleteDialog(true);
  };

  const handleCloseDeleteDialog = async (del) => {
    setDeleteDialog(false);
    if (del === true) {
      await DeleteIncome(IncomeId);
      setDeleteDialog(false);
      setRefresh(!Refresh);
    }
  };
  // Action Confirmation End
  return {
    DeleteDialog,
    handleOpenDeleteDialog,
    handleCloseDeleteDialog,
    AllIncome,
    isLoading,
  };
};

export default IncomeViewModal;
